/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';

import Divider from 'components/Divider';
import UserParentChildSection from '../UserParentChildSection';
import LoadingIndicator from 'components/LoadingIndicator';

import PARENT_CHILD_SECTION_QUERY from './queries/ParentChildSectionQuery.gql';

import type { ParentChildSectionQuery } from './queries/__generated__/ParentChildSectionQuery';

type Props = {
  data: {
    ...ParentChildSectionQuery,
    loading: boolean,
    error: ?Error,
    refetch: () => {},
  },
};

// a user can have either parents or children, not both
export function getRelationInfo(me: ?Object) {
  if (!(me && me.family)) {
    return {};
  }

  if (
    me.family.children.length > 0 ||
    me.family.pending_children.length > 0 ||
    me.permissions.can_add_child
  ) {
    return {
      relation: 'child',
      familyKey: 'children',
      pendingFamilyKey: 'pending_children',
    };
  }
  if (
    me.family.parents.length > 0 ||
    me.family.pending_parents.length > 0 ||
    me.permissions.can_add_parent
  ) {
    return {
      relation: 'parent',
      familyKey: 'parents',
      pendingFamilyKey: 'pending_parents',
    };
  }

  return {};
}

export function ParentChildSection(props: Props) {
  if (props.data.loading) {
    return <LoadingIndicator />;
  }

  const { me } = props.data;

  const { relation, familyKey, pendingFamilyKey } = getRelationInfo(me);

  if (!(me && me.family && relation)) {
    return null;
  }

  return (
    <div className="UserProfileView-section">
      <UserParentChildSection
        relation={relation}
        viewingUserId={me.id}
        permissions={me.permissions}
        relatedUsers={me.family[familyKey]}
        pendingRelatedUsers={me.family[pendingFamilyKey]}
        refetchProfile={props.data.refetch}
      />
      <Divider size="large" />
    </div>
  );
}

const withData = graphql(PARENT_CHILD_SECTION_QUERY);

export default withData(ParentChildSection);
